
import { RotaProvider } from "../Contexts/RotaContext";
import { useParams } from "react-router-dom";
import RotasModulo from "../pages/Rotas/index";

const MapaComRota = () => {
  const { idFeira } = useParams();

  return (
    <RotaProvider>
      <RotasModulo/>
    </RotaProvider>

  );
};

export default MapaComRota;